module.exports = __webpack_public_path__ + "img/公司简介.de49f2e4.png";